import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import moment from "moment";
import { getUserAvatarIcon } from "features/metadesk/utils";
import Button, { VARIANT } from "@metacrm/metacrm-material-ui/dist/Button";
import { useIntl } from "react-intl";

const MentionItem = ({
  senderHandle,
  content,
  date,
  keyword,
  platform,
  handleExcludeUser = () => {},
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const icon = getUserAvatarIcon("6475bb179565b6c7ef71a110", theme);

  const renderHighlightKeyword = ({ content, keyword }) => {
    // 將特殊字元進行跳脫處理
    const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // 將 keyword 跳脫後生成正則表達式
    const escapedKeyword = escapeRegExp(keyword);

    // 使用正則表達式替換關鍵字，加上 <strong> 標籤
    const highlightedContent = content.replace(
      new RegExp(`(${escapedKeyword})`, "gi"), // 匹配跳脫後的關鍵字 (忽略大小寫)
      "<strong style='font-weight:900'>$1</strong>" // 將關鍵字用 <strong> 包裹
    );

    return (
      // 使用 dangerouslySetInnerHTML 來渲染 HTML 標籤
      <div dangerouslySetInnerHTML={{ __html: highlightedContent }} />
    );
  };
  return (
    <Box
      sx={{
        "&:not(:last-child)": {
          borderBottom: `1px solid ${theme.customColors.grey[300]}`,
          paddingBottom: "16px",
          marginBottom: "16px",
        },
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px",
          justifyContent: "space-between",
        }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component={"img"}
            src={require(`assets/img/${icon}`)}
            sx={{ width: "20px", height: "20px", mr: "4px" }}
          />
          <Box sx={{ fontSize: "12px", color: theme.customColors.grey[700] }}>
            {senderHandle}
          </Box>
        </Box>
        <Button
          variant={VARIANT.TEXT}
          style={{
            padding: "0px",
            height: "fit-content",
            fontSize: 12,
            fontWeight: theme.fontWeight.BOLD,
          }}
          onClick={() =>
            handleExcludeUser({
              excludeType: "user",
              platformType: platform,
              identifier: senderHandle,
            })
          }>
          {formatMessage({
            id: "communityAnalysis.popup.keywordMentions.excludeByUser",
          })}
        </Button>
      </Box>
      <Box
        sx={{
          fontSize: "13px",
          color: theme.customColors.grey[700],
          marginBottom: "8px",
        }}>
        {renderHighlightKeyword({ content, keyword })}
      </Box>
      <Box sx={{ fontSize: "12px", color: theme.customColors.grey[600] }}>
        {moment(date).utc().format("D MMM, YYYY hh:mm A")}
      </Box>
    </Box>
  );
};

export default MentionItem;
